import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {enrichCustomerProfileActivityGroupsWithLifecycleStatus} from "~/components/entityProfile/activity/enrichCustomerProfileActivityGroups";
import {MOCK_CUSTOMER_PROFILE_LIFECYCLE_BASES} from "~/components/entityProfile/lifecycle/mockCustomerProfileLifecycles";
import {MOCK_CUSTOMER_PROFILE_JOURNEYS} from "~/components/entityProfile/mockCustomerProfileJourneys";
import {
    CUSTOMER_PROFILE_MOCK_API_DELAY_MS,
} from "~/components/entityProfile/customerProfileDataSource/config";
import type {
    CustomerProfileDataSource,
    CustomerProfileTabApiData,
} from "~/components/entityProfile/customerProfileDataSource/types";
import {MOCK_CUSTOMER_PROFILE_ACTIVITY_GROUPS} from "~/components/entityProfile/customerProfileDataSource/mock/mockCustomerProfileActivity";
import {MOCK_CUSTOMER_PROFILE_NOTES} from "~/components/entityProfile/customerProfileDataSource/mock/mockCustomerProfileNotes";

function delay(ms: number): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

async function fetchMockCustomerProfileTabData(args: {
    customerId: Uuid;
}): Promise<CustomerProfileTabApiData> {
    await delay(CUSTOMER_PROFILE_MOCK_API_DELAY_MS);

    void args.customerId;

    return {
        lifecycleBases: MOCK_CUSTOMER_PROFILE_LIFECYCLE_BASES,
        journeys: MOCK_CUSTOMER_PROFILE_JOURNEYS,
        activityGroups: enrichCustomerProfileActivityGroupsWithLifecycleStatus(
            MOCK_CUSTOMER_PROFILE_ACTIVITY_GROUPS,
            MOCK_CUSTOMER_PROFILE_LIFECYCLE_BASES,
        ),
        notes: MOCK_CUSTOMER_PROFILE_NOTES,
    };
}

export const mockCustomerProfileDataSource: CustomerProfileDataSource = {
    fetchTabData: fetchMockCustomerProfileTabData,
};
